
import { Component, Prop, Vue } from "vue-property-decorator";
import { DimssaButton, ButtonState } from "@/components/shared/dimssa-button.vue";
import FeedDeliverySummary from "@/views/FeedDeliverySummary.vue";
import CribsSummaryPlan from "./CribPlan.vue";
import FeedSchedule from "./FeedSchedule.vue";

import * as Model from "@gigalot/data-models";
import lodash from "lodash";
import moment from "moment";
import Decimal from "decimal.js";
import { onUnmounted } from "vue";

@Component({
  components: {
    DimssaButton,
    FeedDeliverySummary,
    CribsSummaryPlan,
    FeedSchedule,
  },
})
export default class Replay extends Vue {
  newNote: string = "";
  defaultDateSelected = this.formatDate(new Date());
  dateSelected = "";
  keys = ["Kraal", "Ration", "Score", "Call", "Drive Order"];
  itemsPerPage = 1;
  cribHistoryHeader = [
    { text: "Date", value: "readingDate", align: "center" },
    { text: "Animals", value: "animalCount", align: "center" },
    { text: "Ration", value: "ration", align: "center" },
    { text: "Score", value: "score", align: "center" },
    { text: "Call", value: "call", align: "center" },
    { text: "Fed", value: "actualFed", align: "center" },
  ];

  mounted() {
   

  }
  isPlaying = false;

  togglePlay() {
    this.isPlaying = !this.isPlaying;
    if (this.isPlaying) {
      this.startPlayback();
    } else {
      this.pausePlayback();
    }
  }
  async startPlayback() {
    let url = `${this.$store.getters["backendUrl"]()}/startPlayback`;
    let res = await fetch(url, {
      method: "GET",
    });
    if (!res.ok) throw Error("Response OK : " + (await res.text()));
  }

  async pausePlayback() {
      let url = `${this.$store.getters["backendUrl"]()}/pausePlayback`;
    let res = await fetch(url, {
      method: "GET",
    });
    if (!res.ok) throw Error("Response OK : " + (await res.text()));
  }

  async stepForward() {
      let url = `${this.$store.getters["backendUrl"]()}/stepForward`;
    let res = await fetch(url, {
      method: "GET",
    });
    if (!res.ok) throw Error("Response OK : " + (await res.text()));
  }
  async stepBack() {
      let url = `${this.$store.getters["backendUrl"]()}/stepBack`;
    let res = await fetch(url, {
      method: "GET",
    });
    if (!res.ok) throw Error("Response OK : " + (await res.text()));
  }

  async fastForward() {
         let url = `${this.$store.getters["backendUrl"]()}/fastForward`;
    let res = await fetch(url, {
      method: "GET",
    });
    if (!res.ok) throw Error("Response OK : " + (await res.text()));
  }
  async rewind() {
          let url = `${this.$store.getters["backendUrl"]()}/rewind`;
    let res = await fetch(url, {
      method: "GET",
    });
    if (!res.ok) throw Error("Response OK : " + (await res.text()));
  }

  async loadReplay() {
    console.log(`Date selected: ${this.dateSelected}`);
    if (this.dateSelected.indexOf('-') == 4){
      this.defaultDateSelected = this.reverseDateSelected(this.dateSelected)
    }
         let url = `${this.$store.getters["backendUrl"]()}/loadPlayback?date=${this.defaultDateSelected}`;
    let res = await fetch(url, {
      method: "GET",
    });
    if (!res.ok) throw Error("Response OK : " + (await res.text()));
  }
  
  reverseDateSelected(date:string){
    return `${date.slice(8,10)}-${date.slice(5,7)}-${date.slice(0,4)}`
  }

  formatDate(date: any) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
}
}
